import * as React from "react";
import { buildQueryString } from "../../../store/base";

import {
  OverviewSubtitle,
  OverviewTitle,
  OverviewTitleWithSubtitleWrapper,
  OverviewTitleWrapper,
} from "../../Details/OverviewInfo/styles";
import { TextButton } from "../../Forms/Base/Buttons";
import LocalTableSelectField from "src/components/Forms/Base/Fields/LocalTableSelectField";
import ApartmentTable from "src/components/Tables/Apartments/FullTableNewVersion";

export default ({ buildingId, goBack, selectPremises, selectedPremises }) => {
  const q = buildQueryString({
    building: buildingId,
  });

  return (
    <>
      <TextButton
        title="Tillbaka"
        clicked={goBack}
        iconType="arrow-back"
        extraStyle={{ marginBottom: 12 }}
      />

      <OverviewTitleWrapper>
        <OverviewTitleWithSubtitleWrapper>
          <OverviewTitle>Koppla rum till lägenhet</OverviewTitle>
          <OverviewSubtitle>
            Välj en lägenhet att koppla de valda ytorna till
          </OverviewSubtitle>
        </OverviewTitleWithSubtitleWrapper>
      </OverviewTitleWrapper>

      <div className="grid grid-cols-2 gap-6 mb-6">
        <LocalTableSelectField
          TableComponent={ApartmentTable}
          placeholder="Välj lägenhet..."
          title="Lägenhet"
          value={selectedPremises}
          persistantQuery={q}
          onChange={(obj) => {
            selectPremises(obj);
          }}
        />
      </div>
    </>
  );
};
